import React, { useEffect, useState } from 'react';
import locationContext from '../contexts/location';
import firebase from '../../preorder/services/firebase';
import ProgressBackdrop from '../../preorder/components/ProgressBackdrop';

const path = `/${process.env.REACT_APP_MODE}/location/data`;
const locationRef = firebase.database().ref(path);

export default (WrappedComponent) => () => {
  const [location, setLocation] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    locationRef.on('value', (snapshot) => {
      const data = snapshot.val();
      setLocation(data || {});
      setIsLoading(false);
    }, () => {
      setIsLoading(false);
    });

    return () => {
      locationRef.off('value');
    };
  }, [setIsLoading]);

  return (
    <locationContext.Provider value={{ location, isLoading }}>
      <WrappedComponent />
      <ProgressBackdrop isShow={isLoading} />
    </locationContext.Provider>
  );
};
